module.exports = __webpack_public_path__ + "img/peaks-xs.7541a228.svg";